export default "__VITE_ASSET__CTSQyj$l__"